/* eslint-disable */
if (
  typeof String !== undefined
  && String.prototype
  && !String.prototype.truncate
) {
  Object.defineProperty(String.prototype, 'truncate', {
    value(limit, {
      position = 'end',
      replacement = '...',
      beforeLimit = 10,
      afterLimit = 5,
      isFilename = false,
    } = {}) {
      if (this.length <= limit) return this;
      let string = this;
      let extension = '';
      if (isFilename) {
        const split = this.split('.');
        string = split.slice(0, -1).join('.');
        extension = split[split.length - 1];
      }
      if (['front', 'start', 'beginning', 'before'].includes(position)) {
        if (isFilename) {
          return `${replacement}${string.substring(string.length - (limit + extension.length))}.${extension}`;
        }
        return `${replacement}${string.substring(string.length - limit)}`;
      } else if (['middle', 'center'].includes(position)) {
        if (isFilename) {
          return `${string.substring(0, beforeLimit)}${replacement}${string.substring(string.length - afterLimit)}.${extension}`;
        }
        return `${string.substring(0, beforeLimit)}${replacement}${string.substring(string.length - afterLimit)}`;
      } else if (['back', 'end', 'rear', 'after'].includes(position)) {
        if (isFilename) {
          return `${string.substring(0, limit - extension.length)}${replacement}.${extension}`;
        }
        return `${string.substring(0, limit)}${replacement}`;
      }
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  });
}